import React, { CSSProperties, HTMLAttributes } from 'react';
import '../../../stylesheets/stylesComponents/card-component.scss';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    className?: string;
    style?: CSSProperties;
}

const Card = (props: CardProps) => {
    const { children, className, ...restProps } = props;
    return (
        <div className={`card-component ${className}`} {...restProps}>
            {children}
        </div>
    );
};

export default Card;
